import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { pickBy } from 'lodash';
import displayName from 'component-lib/displayName';

import styles from './style.scss';

export default class DropdownPanel extends Component {
    static displayName = displayName('CompositeComponents/DropdownPanel');

    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    setRef = (panel) => {
        this.DOMNode = panel;
    };

    render() {
        const panelProps = {
            className: styles.panel,
            ref: this.setRef,
            ...pickBy(this.props, (v, k) => k.indexOf('data-') === 0),
        };

        return (
            <div {...panelProps}>
                {this.props.children}
            </div>
        );
    }
}
